export class SimilarityIndexError extends Error {

}
